import { createIcon } from './factory'
import Icon from './shopping-cart.svg?react'

export const ShoppingCart = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
